var CryptoJS = require("crypto-js");
export default {
  drupal_url: process.env.REACT_APP_drupal_url,
  rest_node_url: process.env.REACT_APP_rest_node_url,
  AzureMapFixlatitude: process.env.REACT_APP_AzureMapFixlatitude,
  AzureMapFixlongitude: process.env.REACT_APP_AzureMapFixlongitude,
  AzureMapKey: process.env.REACT_APP_AzureMapKey,
  news_url: process.env.REACT_APP_news_url,
  japan_url: process.env.REACT_APP_japan_url,
  bannertext_linescount: process.env.REACT_APP_bannertext_linescount,
  global_default_hash: process.env.REACT_APP_global_default_hash,
  appinsights_key: process.env.REACT_APP_appinsights_key,
  deck_lower: process.env.REACT_APP_deck_lower,
  deck_upper: process.env.REACT_APP_deck_upper,
  cms_sunset_message_title: process.env.REACT_APP_cms_sunset_message_title,
  cms_sunset_message_body_enhanced: process.env.REACT_APP_cms_sunset_message_body_enhanced,
  cms_sunset_message_body_access: process.env.REACT_APP_cms_sunset_message_body_access,
  cms_sunset_message_body_assistance: process.env.REACT_APP_cms_sunset_message_body_assistance,
  cms_sunset_redirect_url: process.env.REACT_APP_cms_sunset_redirect_url,
  cms_sunset_message_enable:
    process.env.REACT_APP_cms_sunset_message_enable === "true",
}
